import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext, useState, useRef, useEffect, useMemo } from 'react';
import clsx from 'clsx';
import PageNavigationContext from './PageNavigationContext.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Text } from '../../display/Text/Text.es.js';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import { Spacer } from '../../layout/Spacer/Spacer.es.js';
import NestedSecondRow from './NestedSecondRow.es.js';
import PageNavigationBadge from './PageNavigationBadge.es.js';
import PageNavigationRow from './PageNavigationRow.es.js';
import checkIsTruncated from './utils/checkIsTruncated.es.js';

const list = "_list_1x3ia_1";
const textEllipsis = "_text-ellipsis_1x3ia_8";
const textWrap = "_text-wrap_1x3ia_14";
const rowContainer = "_row-container_1x3ia_21";
const iconContainer = "_icon-container_1x3ia_30";
const iconTextSpacing = "_icon-text-spacing_1x3ia_40";
const styles = {
	list: list,
	textEllipsis: textEllipsis,
	textWrap: textWrap,
	rowContainer: rowContainer,
	iconContainer: iconContainer,
	iconTextSpacing: iconTextSpacing
};

function NestedFirstRow({ isExpanded, item, onSelect }) {
  const { toggleExpand } = useContext(PageNavigationContext);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  const nestedListRef = useRef(null);
  useEffect(() => {
    if (nestedListRef.current) {
      if (isExpanded) {
        nestedListRef.current.removeAttribute("hidden");
      } else {
        nestedListRef.current.setAttribute("hidden", "until-found");
      }
    }
  }, [isExpanded]);
  useEffect(() => {
    setIsTruncated(checkIsTruncated(textRef));
  }, []);
  const onToggleSelect = () => {
    toggleExpand(item.id);
    return onSelect;
  };
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    return jsxs("div", { className: styles.rowContainer, "data-testid": "pagenavigation-nestedfirstrow", "data-zds": true, children: [jsxs("span", { className: styles.textWrap, children: [item.children ? jsx("div", { className: styles.iconContainer, "data-testid": "pagenavigation-nestedfirstrow-icon", "data-zds": true, children: jsx(Icon, { color: "GrayWarm6", name: isExpanded ? "arrowSmallUp" : "arrowSmallDown", size: 20 }) }) : jsx(Spacer, { width: 20 }), jsx("span", { className: clsx(styles.textEllipsis, item.children && styles.iconTextSpacing), style: { color: Colors[textColor] }, "data-testid": "pagenavigation-nestedfirstrow-text", ref: textRef, "data-zds": true, children: jsx(Text, { color: textColor, margin: "0 0 0 8px", type: "Body3", children: item.title }) })] }), item.count && jsx(PageNavigationBadge, { variant: "neutral", children: item.count.toString() })] });
  };
  const Content = ({ hover, selected }) => isTruncated ? jsx(TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast", children: () => jsx(InnerContent, { hover, selected }) }) : jsx(InnerContent, { hover, selected });
  const NestedList = useMemo(() => item.children ? () => {
    var _a;
    return jsx("ul", { className: styles.list, "data-zds": true, hidden: !isExpanded, ref: nestedListRef, children: (_a = item.children) === null || _a === void 0 ? void 0 : _a.map((i) => jsx(NestedSecondRow, { item: i, onSelect }, i.id)) });
  } : void 0, [item, isExpanded, onSelect]);
  return jsx(PageNavigationRow, { content: Content, isSelectable: false, item, nestedList: NestedList, onSelect: item.children ? onToggleSelect : onSelect });
}

export { NestedFirstRow as default };
//# sourceMappingURL=NestedFirstRow.es.js.map
